import { ShowMoreProps } from '../show-more'
import ShowMore from '../show-more'
export default function withShowMore(props: ShowMoreProps) {
  function WrapperComponent(props: ShowMoreProps) {
    return <ShowMore {...props} />
  }
  return WrapperComponent(props)
}
